import { useSelector } from "react-redux";
import { LoaderTwo } from "../../../../components/loader/LoaderTwo";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getSingleClaim, resetClaimStatus, updateSavingsClaim } from "../../../../redux/slice/claim/savingClaimSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../../../../components/partials/PageTitle";
import moment from "moment";
import RichTextEditor from "../../../../components/form/RichTextEditor";
import { AiFillEye, AiOutlineDownload } from "react-icons/ai";
import { dejoinBy_, handleDownload } from "../../../../utils/helpers/functions";
import { formatDynamicValues, joinBy_ } from "./CoverInfo";
import useFileUpload from "../../../../utils/hooks/useFileUpload";
import { useFormik } from "formik";
import { flashMessage as flash } from "../../../../utils/flash";
import ModalContainer from "../../../../components/modals/ModalContainer";
import ApproveSavingsClaim from "../../../../components/modals/claims/ApproveSavingsClaim";
import DeclineSavingsClaim from "../../../../components/modals/claims/DeclineSavingsClaim";
import { FileUploader } from "react-drag-drop-files";
import { getClaimComments } from "../../../../redux/slice/claim/claimSlice";
import ClaimComment from "../../../../components/modals/claims/ClaimComment";


const dynamicFields = (dynamic_values) => {
    const objectData = {};
    if (dynamic_values) {
        for (const element of dynamic_values) {
            objectData[element.field_name] = element.value;
        }
        return objectData;
    }
  };

const SingleSavingsClaim = () => {

    const { single_claim, isUpdated, approveSuccess, declineSuccess } = useSelector((state) => state.savingsClaim);
    const { claim_comments } = useSelector((state) => state.claim);
    const { user, user_role, user_permissions } = useSelector((state) => state.auth.user);
    const { all_covers } = useSelector((state) => state.cover);

    const [desc, setDesc] = useState()
    const [fileList, setFileList] = useState([])
    const [editClaim, setEditClaim] = useState(false)
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [detailsOfLoss, setDetailsOfLoss] = useState("");
    const [commentItem, setCommentItem] = useState(false);
    const [hasEditClaim, setHasEditClaim] = useState(null);

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { state } = useLocation();

    const breadcrumb = {
        from: {
          title: "Savings Policy Claims",
          link: "/admin/claims/all-savings-claims",
        },
        current: {
          title: "View Claim",
          link: null,
        },
    };

    const { fileUrl, singleFileUpload } = useFileUpload();

    const handleCustomFileChange = (name, e) => {
        e.preventDefault();
        setIsUploading(true);
        singleFileUpload(e.target.files[0]);
        setSelectedFile(name);
    };

    const onSubmit = (values) => {
        if (fileList.length < 1) {
          flash("error", "Document is required");
          return;
        }
        let payload = {
            id: single_claim?.single_claim_process_details?.id,
            claim_category: single_claim?.single_claim_process_details?.claim_category,
            claim_type: single_claim?.single_claim_process_details?.claim_type,
            life_insurance: single_claim?.single_claim_process_details?.life_insurance,
            amount_payable: values?.amount_payable,
            interest: single_claim?.single_claim_process_details?.InterestAmount,
            total_contribution_paid: single_claim?.single_claim_process_details?.total_contribution_paid,
            new_balance_after_with_drawal_fee: single_claim?.single_claim_process_details?.new_balance_after_with_drawal_fee,
            balance_in_account: single_claim?.single_claim_process_details?.balance_in_account,
            last_contribution_date: single_claim?.single_claim_process_details?.last_contribution_date,
            termination_fee: single_claim?.single_claim_process_details?.termination_fee,
            with_drawal_fee: single_claim?.single_claim_process_details?.withdrawal_fee,
            desc: desc,
            details_of_loss: detailsOfLoss,
            policy_application_number: single_claim?.single_claim_process_details?.policyAppNumber,
            documents: fileList,
            claim_form: formatDynamicValues(
                values,
                JSON.parse(single_claim?.single_claim_process_details?.dynamic_fields) || []
            ),
            date_of_loss: values.date_of_loss,
            claim_amount: values.claim_amount,
            premium_paid_date: single_claim?.single_claim_process_details?.last_premium_paid_date,
            total_premium_paid: single_claim?.single_claim_process_details?.total_premium_paid,
            reason_for_claim: values.reason_for_claim,
            staff_id: user?.staff_id,
            policy_cover: single_claim?.single_claim_process_details?.policy_cover,
            customer_id: single_claim?.single_claim_process_details?.customerId,
            garranty_type: single_claim?.single_claim_process_details?.garranty_type,
        };
        
        dispatch(updateSavingsClaim(payload));
    };

    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        resetForm,
      } = useFormik({
        enableReinitialize: true,
        initialValues: {
            policy_cover: single_claim?.single_claim_process_details?.policy_cover,
            // date_of_loss: single_claim?.single_claim_process_details?.date_of_loss,
            amount_payable: single_claim?.single_claim_process_details?.amount_payable,
            premium_paid_date: single_claim?.single_claim_process_details?.premium_paid_date,
          claim_amount: single_claim?.single_claim_process_details?.claim_amount,
          last_premium_paid_date: single_claim?.single_claim_process_details?.last_premium_paid_date,
          total_premium_paid:
            single_claim?.single_claim_process_details?.total_premium_paid,
          reason_for_claim:
            single_claim?.single_claim_process_details?.reason_for_claim,
          date_of_loss: single_claim?.single_claim_process_details?.date_of_loss,
          document: [],
          garranty_type: single_claim?.single_claim_process_details?.garranty_type,
          ...dynamicFields(parseDynamicFields(single_claim?.single_claim_process_details?.dynamic_fields)),
        },
        validate: (values) => {
          let errors = {};
          let customFormCompulsoryFields =
          JSON.parse(single_claim?.single_claim_process_details?.dynamic_fields)?.filter(
              (items) => items?.compulsory_field === 1
            );
          customFormCompulsoryFields?.forEach((field) => {
            const fieldName = joinBy_(field?.field_name);
            const value = values[fieldName];
    
            if (value === "") {
              errors[fieldName] = fieldName + " is required.";
            }
          });
            if (!values?.amount_payable) {
              errors.amount_payable = "Amount Payable is required.";
            }
          return errors;
        },
    
        onSubmit,
      });

      function parseDynamicFields(dynamicFields) {
        try {
          return JSON.parse(dynamicFields ? dynamicFields : "[]");
        } catch (error) {
          console.error("Failed to parse dynamic fields JSON:", error);
          return [];
        }
      }

      useEffect(() => {
        if (fileUrl && selectedFile !== "document-upload") {
          setFieldValue(selectedFile, fileUrl);
          setSelectedFile(selectedFile);
          setIsUploading(false);
        }
      }, [fileUrl]);

    // useEffect(() => {
    //   dispatch(getSingleClaim({
    //     claim_type: state.claim_type, claim_category: state.claim_category, claim_id: state.claim_id, policy_application_number: state.policy_application_number, customer_id: state.customer_id
    //   }))
    // }, [dispatch, state.claim_category, state.claim_id, state.claim_type, state.customer_id, state.policy_application_number])

    useEffect(() => {
        // get single claim on page load or reload
        if (!isUpdated || approveSuccess || declineSuccess) {
            dispatch(getSingleClaim({
                claim_type: state?.claim_type, claim_category: state?.claim_category, claim_id: state?.claim_id, policy_application_number: state?.policy_application_number, customer_id: state?.customer_id
              }))
        }
    
        if (isUpdated) {
          dispatch(resetClaimStatus());
          navigate("/admin/claims/all-savings-claims");
        }
      }, [isUpdated, approveSuccess, declineSuccess]);

    useEffect(() => {
        setDesc(
          single_claim?.single_claim_process_details?.desc
        );
        setDetailsOfLoss(
            single_claim?.single_claim_process_details?.details_of_loss
        );
        setFileList(
          single_claim?.single_claim_process_details?.documents &&
            JSON.parse(single_claim?.single_claim_process_details?.documents)
        );
        // dispatch(resetCustomerSinglePolicyDetailsView());
      }, [single_claim]);

      useEffect(() => {
        dispatch(
          getClaimComments({
            claim_uuid: single_claim?.single_claim_process_details?.id,
            claim_id: single_claim?.single_claim_process_details?.claim_id,
          })
        );
      }, [
        dispatch,
        single_claim?.single_claim_process_details?.claim_id,
        single_claim?.single_claim_process_details?.id,
      ]);

      useEffect(() => {
        if (
          !user_permissions?.some(
            (permission) => permission.name === "claim module"
          ) ||
          !user_permissions?.some((permission) => permission.name === "view claim")
        ) {
          navigate("/admin/dashboard");
        }
    
        setHasEditClaim(
          user_permissions?.some((permission) => permission.name === "edit claim")
        );
      }, [navigate, user_permissions]);
    

    if (!single_claim) {
        return (
          <div className='mt-2'>
            <LoaderTwo />
          </div>
        );
    }
  return (
    <div>
        <PageTitle title='View Claim' breadcrumb={breadcrumb} />
        <div className='row'>
            <div className='col-md-12'>
                <div className='card p-3'>
                    <div>
                        <h4 className='text-primary'>Policy Information</h4>
                        <div className='row'>
                            <div className='col-md-12 col-lg-10'>
                                <div className='row'>
                                    <div className='col-md-6 mt-1 '>
                                        <span className='fw-bold me-2'>Customer Name: </span>
                                        <Link
                                            to={`/admin/customer-profile/${single_claim?.single_claim_process_details?.customer_basic_id}`}
                                        >
                                            {single_claim?.single_claim_process_details
                                            ?.customerFirstName +
                                            " " +
                                            single_claim?.single_claim_process_details
                                                ?.customerLastName}
                                        </Link>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Customer Id: </span>
                                        <span>
                                            {single_claim?.single_claim_process_details?.customerId}
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                    <span className='fw-bold me-2'>Marketer/Agent: </span>
                                    <span>
                                        {single_claim?.single_claim_process_details
                                        ?.agentFirstName +
                                        single_claim?.single_claim_process_details
                                            ?.agentLastName}
                                    </span>
                                    </div>
                                    <div className='col-md-6 mt-2 '>
                                    <span className='fw-bold me-2'>Policy No: </span>
                                    <Link
                                        to={`/admin/customer-savings-policy-view`}
                                        state={{
                                        customerId:
                                            single_claim?.single_claim_process_details
                                            ?.customerId,
                                        policyAppNumber:
                                            single_claim?.single_claim_process_details
                                            ?.policyAppNumber,
                                        }}
                                    >
                                        {
                                        single_claim?.single_claim_process_details
                                            ?.policyAppNumber
                                        }
                                    </Link>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                    <span className='fw-bold me-2'>Policy Name: </span>
                                    <span>
                                        {single_claim?.single_claim_process_details?.policyName}
                                    </span>
                                    {/* <span>{policyHolder?.policyName}</span> */}
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                    <span className='fw-bold me-2'>Status: </span>
                                    {single_claim?.single_claim_process_details?.status ? (
                                        <>
                                        <span className='badge badge-success-lighten'>
                                            {single_claim?.single_claim_process_details
                                            ?.status === "2" && "Active"}
                                        </span>
                                        <span className='badge badge-warning-lighten'>
                                            {single_claim?.single_claim_process_details
                                            ?.status === "1" && "Pending"}
                                        </span>
                                        <span className='badge badge-info-lighten'>
                                            {single_claim?.single_claim_process_details
                                            ?.status === "3" && "Matured"}
                                        </span>
                                        <span className='badge badge-danger-lighten'>
                                            {single_claim?.single_claim_process_details
                                            ?.status === "4" && "Terminated"}
                                        </span>
                                        <span className='badge badge-danger-lighten'>
                                            {single_claim?.single_claim_process_details
                                            ?.status === "5" && "Death"}
                                        </span>
                                        {/* <span className='badge badge-danger-lighten'>
                                            {policyHolder?.status === "4" && "Claim Processed"}
                                        </span> */}
                                        </>
                                    ) : null}
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Duration: </span>
                                        <span>
                                            {single_claim?.single_claim_process_details?.duration
                                            ? single_claim?.single_claim_process_details
                                                ?.duration + "months"
                                            : null}
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Life Cover: </span>
                                        <span>
                                            {single_claim?.policy_info_details?.life_cover?.life_cover_name
                                            ? single_claim?.policy_info_details?.life_cover?.life_cover_name
                                            : null}
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Effective Date: </span>
                                        <span>
                                            {moment(
                                            single_claim?.single_claim_process_details
                                                ?.effectiveDate
                                            ).format("LL")}
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                    <span className='fw-bold me-2'>End Date: </span>
                                    <span>
                                        {moment(
                                        single_claim?.single_claim_process_details?.endDate
                                        ).format("LL")}
                                    </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Total Premium: </span>
                                        <span>
                                            &#8358;
                                            {
                                            single_claim?.policy_info_details?.policy_app_details?.total_premium
                                            }
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Sum Assured: </span>
                                        <span>
                                            &#8358;
                                            {
                                            single_claim?.policy_info_details?.policy_app_details?.sumAssured
                                            }
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Total Deposit: </span>
                                        <span>
                                            &#8358;
                                            {
                                            single_claim?.policy_info_details?.total_deposit
                                            }
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Last Deposit: </span>
                                        <span>
                                            &#8358;
                                            {
                                            single_claim?.policy_info_details?.last_deposit
                                            }
                                        </span>
                                    </div>
                                    <div className='col-md-6 mt-2'>
                                        <span className='fw-bold me-2'>Current Balance: </span>
                                        <span>
                                            &#8358;
                                            {
                                            single_claim?.policy_info_details?.current_balance
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form 
                            onSubmit={handleSubmit}
                        >
                            <div className='pt-3'>
                                <h4 className='text-primary'>Claims Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                        Claim Number
                                        </label>
                                        <p className='text-capitalize'>
                                        {single_claim?.single_claim_process_details?.claim_id}
                                        </p>
                                    </div>
                                    <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                        Claim Category
                                        </label>
                                        <p className='text-capitalize'>
                                        {
                                            single_claim?.single_claim_process_details?.claim_category === 'savings_claim' ? 'Savings Claim' : 'Other Cover'
                                        }
                                        </p>
                                    </div>
                                    {single_claim?.single_claim_process_details?.claim_category === 'savings_claim' && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                        Claim Type
                                        </label>
                                        <p className='text-capitalize'>
                                            {single_claim?.single_claim_process_details?.claim_type === '1' && 'Maturity'}
                                            {single_claim?.single_claim_process_details?.claim_type === '2' && 'Termination'}
                                            {single_claim?.single_claim_process_details?.claim_type === '3' && 'Partial Withdrawal'}
                                            {single_claim?.single_claim_process_details?.claim_type === '4' && 'Death Benefit'}
                                        </p>
                                    </div>}
                                    {single_claim?.single_claim_process_details?.claim_category === 'other_cover' && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                        Policy Cover
                                        </label>
                                        <p className='text-capitalize'>
                                            {
                                                all_covers?.unpaginated_cover?.filter(
                                                (cover) =>
                                                    String(single_claim?.single_claim_process_details?.policy_cover) === String(cover.id))[0].name
                                            }
                                        </p>
                                    </div>}
                                </div>
                                {single_claim?.single_claim_process_details?.claim_category === "other_cover" && 
                                    <div className='row'>
                                        <div className='col-sm-6 col-md-4 mb-3'>
                                        <label htmlFor='premium_paid_date' className='form-label'>
                                            Last premium paid Date <span className='text-danger'>*</span>
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {moment(single_claim?.single_claim_process_details?.last_premium_paid_date).format("DD-MM-YYYY")}
                                        </p>
                                        </div>
                                        <div className='col-sm-6 col-md-4 mb-3'>
                                        <label htmlFor='total_premium_paid' className='form-label'>
                                            Total Premium paid <span className='text-danger'>*</span>
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {single_claim?.single_claim_process_details?.total_premium_paid}
                                        </p>
                                        </div>
                                        <div className='col-sm-6 col-md-4 mb-3'>
                                            <label htmlFor='claim_amount' className='form-label'>
                                                Claim Amount <span className='text-danger'>*</span>
                                            </label>
                                            {editClaim ? <div>
                                                <input
                                                    type='number'
                                                    name='claim_amount'
                                                    id='claim_amount'
                                                    value={values.claim_amount}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className={`form-control form-control-sm ${
                                                    errors.claim_amount && touched.claim_amount && "is-invalid"
                                                    }`}
                                                />
                                                {errors.claim_amount && touched.claim_amount ? (
                                                    <span className='fs-5 invalid-feedback'>
                                                    {errors.claim_amount}
                                                    </span>
                                                ) : null}
                                            </div> : 
                                                <p className='form-control border-0 shadow'>
                                                    {
                                                    single_claim?.single_claim_process_details
                                                        ?.claim_amount
                                                    }
                                                </p>
                                            }
                                        </div>
                                        <div className='col-sm-6 col-md-4 mb-3'>
                                        <label htmlFor='reason_for_claim' className='form-label'>
                                            Reason for Claim <span className='text-danger'>*</span>
                                        </label>
                                        {editClaim ? <div>
                                            <input
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                name='reason_for_claim'
                                                value={values.reason_for_claim}
                                                id='reason_for_claim'
                                                className={`form-control form-control-sm ${
                                                errors.reason_for_claim &&
                                                touched.reason_for_claim &&
                                                "is-invalid"
                                                }`}
                                            />
                                            {errors.reason_for_claim && touched.reason_for_claim ? (
                                                <span className='fs-5 invalid-feedback'>
                                                {errors.reason_for_claim}
                                                </span>
                                            ) : null}
                                        </div>: <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details
                                                ?.reason_for_claim
                                            }
                                        </p>}
                                        </div>
                                        <div className='col-sm-6 col-md-4 mb-3'>
                                            <label htmlFor='date_of_loss' className='form-label'>
                                                Date of Loss <span className='text-danger'>*</span>
                                            </label>
                                            {editClaim ? <div>
                                                <input
                                                    type='date'
                                                    name='date_of_loss'
                                                    id='date_of_loss'
                                                    value={values.date_of_loss}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    // max={today}
                                                    className={`form-control form-control-sm ${
                                                    errors.date_of_loss && touched.date_of_loss && "is-invalid"
                                                    }`}
                                                />
                                                {errors.date_of_loss && touched.date_of_loss ? (
                                                    <span className='fs-5 invalid-feedback'>
                                                    {errors.date_of_loss}
                                                    </span>
                                                ) : null}
                                            </div> : <p className='form-control border-0 shadow'>
                                                {
                                                single_claim?.single_claim_process_details
                                                    ?.date_of_loss
                                                }
                                            </p>}
                                        </div>
                                        {/* <div className='col-sm-6 col-md-4 mb-3'>
                                      <label htmlFor='date_of_loss' className='form-label'>
                                        Upload Document
                                        <span className='text-danger'>*</span>
                                        {isUploading && (
                                          <span>
                                            <i className='mdi mdi-dots-circle mdi-spin'></i>{" "}
                                          </span>
                                        )}
                                        {fileList?.length > 0 &&
                                          !isUploading &&
                                          selectedFile === "document-upload" && (
                                            <span>
                                              <i className='mdi mdi-check'></i>
                                            </span>
                                          )}
                                      </label>
                                    <div>
                                        <FileUploader
                                          label='Browse Document'
                                          children={
                                            <div
                                              className={`border-dotted p-1 px-4 text-center cursor-p ${
                                                errors.document && "is-invalid"
                                              }`}
                                              style={{ border: "2px dashed grey" }}
                                              onClick={() => setSelectedFile("document-upload")}
                                            >
                                              <i className='uil uil-cloud-upload fs-4'></i> Upload
                                              Document
                                              <span className='text-primary-dark mt-0'></span>
                                            </div>
                                          }
                                          handleChange={handleFileChange}
                                          onBlur={handleBlur}
                                          // onDrop={handleChange}
                                          name='file'
                                        //   types={fileTypes}
                                        />
                                      </div>
                                      {fileList?.length ? (
                                        <div className='mt-1 sm-mt-3'>
                                          {fileList?.length} file{fileList?.length > 1 && "s"} uploaded{" "}
                                          <span
                                            className='text-info cursor-p'
                                            data-bs-toggle='modal'
                                            data-bs-target='#view_file'
                                          >
                                            view
                                          </span>
                                        </div>
                                      ) : null}
                                        </div> */}
                                    </div>
                                }
                                <div className='row mt-2'>
                                    {(single_claim?.single_claim_process_details?.claim_type !== "1" && single_claim?.single_claim_process_details?.claim_category === "savings_claim") && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                            Total Contribution
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.total_contribution_paid
                                            }
                                        </p>
                                    </div>}
                                    {single_claim?.single_claim_process_details?.claim_category === "savings_claim" && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                            Life insurance
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.life_insurance
                                            }
                                        </p>
                                    </div>}
                                    {single_claim?.single_claim_process_details?.claim_category === "savings_claim" && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                            Balance in Account
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.balance_in_account
                                            }
                                        </p>
                                    </div>}
                                    {(single_claim?.single_claim_process_details?.claim_category === "savings_claim" && single_claim?.single_claim_process_details?.claim_type === "1") && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                            Interest
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.InterestAmount
                                            }
                                        </p>
                                    </div>}
                                    {(single_claim?.single_claim_process_details?.claim_category === "savings_claim" && single_claim?.single_claim_process_details?.claim_type === "2") && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                            Termination Fee
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.termination_fee
                                            }
                                        </p>
                                    </div>}
                                    {single_claim?.single_claim_process_details?.claim_category === "savings_claim" && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                            Amount Payable
                                        </label>
                                        {(single_claim?.single_claim_process_details?.claim_type === '3' || (single_claim?.single_claim_process_details?.claim_type === '4' && values?.garranty_type === 'range'))&& <div>
                                        {!editClaim? 
                                        <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.amount_payable
                                            }
                                            </p> : 
                                            <div>
                                                <input
                                                    type='number'
                                                    name='amount_payable'
                                                    id='amount_payable'
                                                    value={values.amount_payable}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    // max={today}
                                                    className={`form-control form-control-sm ${
                                                    errors.amount_payable && touched.amount_payable && "is-invalid"
                                                    }`}
                                                />
                                                {errors.amount_payable && touched.amount_payable ? (
                                                    <span className='fs-5 invalid-feedback'>
                                                    {errors.amount_payable}
                                                    </span>
                                                ) : null}
                                            </div>
                                        }
                                        </div>}
                                        {(single_claim?.single_claim_process_details?.claim_type !== '3' && !(single_claim?.single_claim_process_details?.claim_type === '4' && values?.garranty_type === 'range')) && <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.amount_payable
                                            }
                                            </p>}
                                    </div>}
                                    {console.log()}
                                    {(single_claim?.single_claim_process_details?.claim_category === "savings_claim" && single_claim?.single_claim_process_details?.claim_type === "3") && <div className='col-md-4'>
                                        <label htmlFor='firstName ' className='fw-bold pb-1'>
                                            Withdrawal Fee
                                        </label>
                                        <p className='form-control border-0 shadow'>
                                            {
                                            single_claim?.single_claim_process_details?.withdrawal_fee
                                            }
                                        </p>
                                    </div>}
                                </div>
                                {single_claim?.single_claim_process_details?.claim_category === "savings_claim" && <div className='col-md-12'>
                                    <label htmlFor='firstName ' className='fw-bold pb-1 mt-2'>
                                    Description
                                    </label>
                                    {editClaim ? (
                                        <div className='mb-3' style={{ height: "250px" }}>
                                            <RichTextEditor
                                                // name='details_of_loss'
                                                // id='details_of_loss'
                                                value={desc}
                                                onChange={(value) => setDesc(value)}
                                                height='200px'
                                            />
                                        </div>
                                    ) : (
                                        <div className='form-control border-0 shadow py-2 px-2'>
                                            <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                single_claim?.single_claim_process_details?.desc,
                                            }}
                                            />
                                        </div>
                                    )}
                                </div>}
                                {single_claim?.single_claim_process_details?.claim_category === "other_cover" && <div className="row">
                                    <label htmlFor='description' className='mb-1'>
                                        Details of Loss
                                    </label>
                                    {editClaim ? <div className='mb-3' style={{ height: "250px" }}>
                                        <RichTextEditor
                                            name='description'
                                            id='description'
                                            value={detailsOfLoss}
                                            onChange={(value) => setDetailsOfLoss(value)}
                                            height='200px'
                                        />
                                    </div> : <div className='form-control border-0 shadow py-2 px-2'>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                single_claim?.single_claim_process_details?.details_of_loss,
                                            }}
                                            />
                                    </div>}
                                </div>}
                            </div>
                            <div className=''>
                                {!editClaim && (
                                <>
                                    <h4 className='pt-3 text-primary'>Documents</h4>
                                    <div>
                                    {fileList?.length &&
                                        fileList?.map((item, index) => (
                                        <div
                                            key={index + "document"}
                                            className='d-flex justify-content-between align-items-center form-control shadow border-0'
                                        >
                                            <span>
                                            {index + 1}. Document-{index + 1}
                                            </span>
                                            <div className='d-flex align-items-center gap-2 text-primary'>
                                            <span
                                                onClick={() => handleDownload(item, index + 1)}
                                                className='cursor-p'
                                            >
                                                <AiOutlineDownload size={20} />
                                            </span>
                                            <a href={item} target='_blank' rel="noreferrer" >
                                                <AiFillEye size={20} />
                                            </a>
                                            </div>
                                        </div>
                                        ))}
                                    </div>
                                </>
                                )}
                            </div>
                            <div className='pt-3'>
                                <h4 className='text-primary'>Custom Form Information</h4>
                                <div className='row'>
                                {single_claim?.single_claim_process_details &&
                                    JSON.parse(single_claim?.single_claim_process_details?.dynamic_fields)?.map((customForm, index) => {
                                    return (
                                        <div className='mb-3 col-sm-9 col-md-7' key={index}>
                                        {customForm?.field_type !== "checkbox" &&
                                        customForm?.field_type !== "file" &&
                                        customForm?.field_type !== "button" ? (
                                            <div>
                                            <label
                                                htmlFor='firstName '
                                                className='fw-bold pb-1'
                                            >
                                                {dejoinBy_(customForm?.field_name)}
                                            </label>

                                            {editClaim ? (
                                                <>
                                                <span>
                                                    {customForm?.compulsory_field === 1 ? (
                                                    <span className='text-danger ms-1'>
                                                        *
                                                    </span>
                                                    ) : null}
                                                </span>
                                                <div>
                                                    <input
                                                    type={`${customForm?.field_type}`}
                                                    name={`${joinBy_(
                                                        customForm?.field_name
                                                    )}`}
                                                    className={`form-control form-control-sm`}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                    autoComplete='off'
                                                      value={
                                                        values[joinBy_(customForm?.field_name)]
                                                      }
                                                    />
                                                </div>
                                                {customForm?.compulsory_field === 1 &&
                                                errors[joinBy_(customForm.field_name)] &&
                                                touched[joinBy_(customForm.field_name)] ? (
                                                    <span className='text-danger'>
                                                    {customForm.field_name} is required
                                                    </span>
                                                ) : null}
                                                </>
                                            ) : (
                                                <>
                                                <p className='form-control border-0 shadow'>
                                                    {customForm?.value}
                                                </p>
                                                </>
                                            )}
                                            </div>
                                        ) : null}

                                        {customForm?.field_type === "checkbox" && (
                                            <div>
                                            <div class='form-check'>
                                                {editClaim ? (
                                                <input
                                                    class={`form-check-input ${
                                                      errors[joinBy_(customForm?.field_name)] &&
                                                      touched[joinBy_(customForm?.field_name)]
                                                    } `}
                                                    type='checkbox'
                                                    name={`${joinBy_(customForm?.field_name)}`}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    defaultChecked={
                                                      values[
                                                        joinBy_(customForm?.field_name)
                                                      ][0] &&
                                                      values[
                                                        joinBy_(customForm?.field_name)
                                                      ][0] === "on"
                                                    }
                                                />
                                                ) : (
                                                <input
                                                    class={`form-check-input`}
                                                    type='checkbox'
                                                    checked={customForm?.value[0]}
                                                />
                                                )}
                                                <label
                                                className='form-check-label fw-bold'
                                                htmlFor='flexCheckDefault'
                                                style={{ marginTop: "2px" }}
                                                >
                                                {dejoinBy_(customForm?.field_name)}
                                                </label>

                                                {customForm?.compulsory_field === 1 && (
                                                <span className='text-danger ms-1'>*</span>
                                                )}
                                            </div>
                                            </div>
                                        )}
                                        {customForm?.field_type === "file" ? (
                                            <div>
                                            <label htmlFor='' className='fw-bold pb-1 me-1'>
                                                {dejoinBy_(customForm?.field_name)}
                                            </label>
                                            {isUploading && (
                                                <span>
                                                <i className='mdi mdi-dots-circle mdi-spin'></i>{" "}
                                                </span>
                                            )}
                                            {values[customForm?.field_name] &&
                                                !isUploading &&
                                                selectedFile === "document-upload" && (
                                                <span>
                                                    <i className='mdi mdi-check'></i>
                                                </span>
                                                )}
                                            {customForm?.value &&
                                                selectedFile === customForm?.field_name &&
                                                !isUploading && (
                                                <span>
                                                    <i className='mdi mdi-check'></i>
                                                </span>
                                                )}
                                            {editClaim ? (
                                                <>
                                                {customForm?.compulsory_field === 1 && (
                                                    <span className='text-danger ms-1'>*</span>
                                                )}
                                                <div>
                                                    <input
                                                    type={`${customForm?.field_type}`}
                                                    name={`${joinBy_(
                                                        customForm?.field_name
                                                    )}`}
                                                    accept='.pdf, image/*'
                                                    className={`form-control form-control-sm`}
                                                    onChange={(e) =>
                                                        handleCustomFileChange(
                                                        `${joinBy_(customForm?.field_name)}`,
                                                        e
                                                        )
                                                    }
                                                      onBlur={handleBlur}
                                                    />
                                                    {customForm?.compulsory_field === 1 &&
                                                    errors[joinBy_(customForm.field_name)] &&
                                                    touched[joinBy_(customForm.field_name)] ? (
                                                    <span className='text-danger'>
                                                        {customForm.field_name} is required
                                                    </span>
                                                    ) : null}
                                                </div>
                                                </>
                                            ) : (
                                                <>
                                                <div className='d-flex justify-content-between align-items-center form-control shadow border-0'>
                                                    <span>
                                                    Download/View {customForm?.field_name}
                                                    </span>
                                                    <div className='d-flex align-items-center gap-2 text-primary'>
                                                    <span
                                                        onClick={() =>
                                                        handleDownload(
                                                            customForm?.value,
                                                            customForm?.field_name
                                                        )
                                                        }
                                                        className='cursor-p'
                                                    >
                                                        <AiOutlineDownload size={20} />
                                                    </span>
                                                    <a
                                                        href={customForm?.value}
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                    >
                                                        <AiFillEye size={20} />
                                                    </a>
                                                    </div>
                                                </div>
                                                </>
                                            )}
                                            </div>
                                        ) : null}
                                        </div>
                                    );
                                    })}
                                </div>
                            </div>
                            <div className=''>
                                {claim_comments?.length > 0 && (
                                <>
                                    <h4 className='pt-3 text-primary'>Comments</h4>
                                    <div>
                                    {claim_comments?.map((item, index) => (
                                        <div
                                        key={index}
                                        className='d-flex justify-content-between align-items-center form-control shadow border-0 mb-2 w-50'
                                        >
                                        <span>{item.user_role}</span>
                                        <div
                                            className='text-primary cursor-p'
                                            onClick={() => {
                                            setCommentItem(item);
                                            }}
                                            data-bs-toggle='modal'
                                            data-bs-target='#comment_view'
                                        >
                                            <span>
                                            <AiFillEye size={20} />
                                            </span>
                                        </div>
                                        </div>
                                    ))}
                                    </div>
                                </>
                                )}
                            </div>
                            <div className='pt-3 d-flex align-items-center gap-2'>
                                {editClaim ? (
                                    <div className='d-flex gap-2'>
                                        <button
                                        type='button'
                                        className='btn btn-sm btn-secondary text-white'
                                        onClick={() => {
                                            setEditClaim(!editClaim);
                                            // resetForm();
                                        }}
                                        >
                                        Close
                                        </button>
                                        <button
                                        type='submit'
                                        className='btn btn-sm btn-primary text-white '
                                        >
                                        Save
                                        </button>
                                    </div>
                                ) : (
                                    <div className='d-flex gap-2'>
                                            {hasEditClaim && single_claim?.single_claim_process_details?.awaiting_status && <button
                                            type='button'
                                            className='btn btn-sm btn-warning text-white'
                                            onClick={() => setEditClaim(!editClaim)}
                                            >
                                            Edit
                                            </button>}
                                            {single_claim?.single_claim_process_details?.decline_status === "0" && user_role.some(
                                                    (role) =>
                                                    role.name ===
                                                    single_claim?.single_claim_process_details
                                                        ?.awaiting_status
                                                ) && (<div className='d-flex align-items-center gap-2'>
                                                <button
                                                    className='btn btn-sm btn-danger'
                                                    data-bs-toggle='modal'
                                                    data-bs-target='#decline_claim'
                                                    type='button'
                                                >
                                                    Decline
                                                </button>
                                                <button
                                                    className='btn btn-sm btn-success'
                                                    data-bs-toggle='modal'
                                                    data-bs-target='#approve_claim'
                                                    type='button'
                                                >
                                                    Approve
                                                </button>
                                            </div>)}
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <ModalContainer
          modal_id='decline_claim'
          modal_width='modal-md'
          bradius='rounded-2'
        >
          <DeclineSavingsClaim
            claim_process_uuid={single_claim?.single_claim_process_details?.id}
            claim_id={single_claim?.single_claim_process_details?.claim_id}
            awaiting_status={
              single_claim?.single_claim_process_details?.awaiting_status
            }
          />
        </ModalContainer>
        <ModalContainer
          modal_id='approve_claim'
          modal_width='modal-md'
          bradius='rounded-2'
        >
          <ApproveSavingsClaim
            claim_details={single_claim?.single_claim_process_details}
          />
        </ModalContainer>
        <ModalContainer
          modal_id='comment_view'
          modal_width='modal-md'
          bradius='rounded-2'
        >
          <ClaimComment data={commentItem || []} />
        </ModalContainer>
    </div>
  )
}

export default SingleSavingsClaim